import { PermissionStructureEnum } from 'domain/permissionStructure/PermissionStructureEnum';

export class PermissionStructure {
  constructor(
    public readonly id: number,
    public readonly code: PermissionStructureEnum,
  ) {}
}
